import React from 'react';

const EmptyBlogPost = () => {
  return (
    <div className="flex flex-col gap-5 justify-center items-center px-4 text-center">
      {/* Icon */}
      <div className="flex justify-center items-center w-16 h-16 bg-orange-50 rounded-2xl ring-1 ring-orange-100">
        <svg
          className="w-8 h-8 text-orange-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 7.5c-1.5 2-3 3.5-3 5.5a3 3 0 006 0c0-2-1.5-3.5-3-5.5z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
          />
        </svg>
      </div>

      {/* Copy */}
      <div className="space-y-1.5">
        <h3 className="text-base font-semibold text-zinc-800">No posts yet</h3>
        <p className="max-w-xs text-sm leading-relaxed text-zinc-500">
          Share your first story — from jollof rice secrets to healthy habits rooted
          in African tradition.
        </p>
      </div>

      {/* CTA */}
      <button
        onClick={() => (window.location.href = '/new-story')}
        className="inline-flex items-center gap-2 rounded-xl bg-[#003232] px-5 py-2.5 text-sm font-medium text-white shadow-sm transition-colors active:scale-[0.98]"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
        </svg>
        Write your first post
      </button>
    </div>
  );
};

export default EmptyBlogPost;
